export const CREATE_JURIDICAL_PERSON_ATTEMPT = 'CREATE_JURIDICAL_PERSON_ATTEMPT';
export type CREATE_JURIDICAL_PERSON_ATTEMPT = typeof CREATE_JURIDICAL_PERSON_ATTEMPT;

export const CREATE_JURIDICAL_PERSON_SUCCESS = 'CREATE_JURIDICAL_PERSON_SUCCESS';
export type CREATE_JURIDICAL_PERSON_SUCCESS = typeof CREATE_JURIDICAL_PERSON_SUCCESS;

export const CREATE_JURIDICAL_PERSON_FAILURE = 'CREATE_JURIDICAL_PERSON_FAILURE';
export type CREATE_JURIDICAL_PERSON_FAILURE = typeof CREATE_JURIDICAL_PERSON_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/juridical-person/create/Types.tsx